// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class NoResultsPlugin {
   appState: any
   config: any
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'NoResult... Remove this comment to see the full error message
      this.prototype.states = ['new']
   }
   constructor(appState: any, configService: any) {
      this.invoke = this.invoke.bind(this)
      this.appState = appState
      this.config = configService.data.results
   }
   invoke(data: any, feed: any) {
      if (data.search.record_count === 0) {
         feed.noResults = true
         const item = {
            query: data.search.query.original_query,
            filtersApplied: _(this.appState.params.fvf).some() || _(this.appState.params.rf).some(),
            holdingsOnly: this.appState.params.ho && this.config.addResultsBeyondCatalog,
            canIncludeFtMatches: !this.appState.params['include.ft.matches'] && this.config.includeMatchesFulltextOverride,
            contactUrl: this.config.librarianContactUrl || false,
            type: 'noResults',
            searchScopeApplied: !!this.appState.params.searchscope && this.appState.params.searchscope !== 'All'
         }
         return feed.addPositionalItem(item, 1)
      }
   }
}
NoResultsPlugin.initClass()

NoResultsPlugin.$inject = ['appStateService', 'configService']

angular.module('summonApp.resultsFeedPlugins')
   .service('noResultsPlugin', NoResultsPlugin)
